import { render, staticRenderFns } from "./UserPlansPro.vue?vue&type=template&id=d21b3882&"
import script from "./UserPlansPro.vue?vue&type=script&lang=js&"
export * from "./UserPlansPro.vue?vue&type=script&lang=js&"
import style0 from "./UserPlansPro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports